import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['gameName', 'isMobile', 'isDesktop']),
    ...mapState('detail', ['ssrConfig']),

    configTemp() {
      // const ssrgames = ['hago']

      // if (ssrgames.includes(this.gameName)) return this.ssrConfig
      return this.$__GAME__
    },
    // 页面的背景颜色[PC]
    pcBackdColor() {
      if (this.isDesktop) {
        return this.mbackdColor
      }
      return {
        backgroundColor: '',
      }
    },

    // 页面的背景颜色[M]
    mbackdColor() {
      return {
        backgroundColor: this.configTemp?.pageBackgroundColor || '',
      }
    },

    // 模块的背景颜色[PC]
    pcModuleBackColor() {
      if (this.isDesktop) {
        return this.moduleBackColor
      }
      return {
        backgroundColor: '',
      }
    },
    // 模块的背景颜色[M]
    moduleBackColor() {
      return {
        backgroundColor: this.configTemp?.moduleBackgroundColor || '',
      }
    },

    // 主要字体颜色[M\PC]
    mFontColor() {
      return {
        color: this.configTemp?.mainFontColor || '',
      }
    },

    // SKU选中颜色[M\PC]
    skuActiveBackColor() {
      return {
        backgroundColor: this.configTemp?.skuBackgroundColor || '',
        borderColor: '#f96000',
        outlineColor: '#f96000',
      }
    },

    // SKU默认颜色[M\PC]
    skuBackColor() {
      return {
        backgroundColor: this.configTemp?.skuBackgroundColor || '',
        borderColor: this.configTemp?.borderColor || '',
        outlineColor: this.configTemp?.borderColor || '',
      }
    },

    // 边框的颜色【全局】
    allBorderColor() {
      return {
        borderColor: this.configTemp?.borderColor || '',
      }
    },

    // 支付通道的颜色[PC\M]
    payBackColor() {
      if (this.isMobile) {
        return {
          color: this.skuBackColor.borderColor,
        }
      }
      return this.skuBackColor
    },

    // 支付区域的背景颜色【PC\M】
    // 首页也在用
    payBgColor() {
      return {
        backgroundColor: this.configTemp?.fPayBgColor || '',
      }
    },
    // 底部价格颜色[PC\M]
    priceColor() {
      return {
        color: this.configTemp?.priceTextColor || '',
      }
    },
    // 提交按钮【PC\M】
    submitBgColor() {
      return {
        background: this.configTemp?.pBtnColor || '',
      }
    },

    // 折扣区域的背景颜色【PC\M】
    discountColor() {
      return {
        backgroundColor: this.configTemp?.sPayBgColor || '',
      }
    },

    // 配置的icon【PC\M】
    gameIcon() {
      return this.configTemp?.iconPic || ''
    },

    // PC的banner【PC】
    pcBackImg() {
      const pic = this.configTemp?.pcBannerPic || ''
      if (!pic) return null
      return {
        backgroundImage: `url('${pic}?f=webp&q=50')`,
      }
    },
    //UID选择模块类型，1：UID+昵称显示，2：server选择+UID+昵称显【PC\M】；6：邮箱
    uidModuleType() {
      return this.configTemp?.uidModuleType || -1
    },

    // tip的引导图【PC\M】
    tipsImg() {
      return this.configTemp?.tipGuidePic || ''
    },
    // 发货类型 1CODE模式 2API模式 3API-CODE模式【PC\M】
    // 只有 == 2 的时候才能显示UID、同理才能校验UID模板
    awardType() {
      return this.configTemp?.awardType || 1
    },
    // GT-头部图 [M\GT],
    getCoverImg() {
      return this.configTemp?.gtTopPic || ''
    },
    // GT-头部图 [M\GT],
    h5BannerPic() {
      return this.configTemp?.h5BannerPic || ''
    },
    // PC底部URL [PC],
    pcBtmUrl() {
      return this.configTemp?.pcBtmUrl || ''
    },

    // 优惠券图标 [PC],
    pcCouponIcon() {
      return this.configTemp?.couponIcon || ''
    },

    // SKU模块类型
    skuModuleType() {
      return this.configTemp?.skuModuleType || 1
    },

    //SKU类型 1非自建SKU 2自建SKU
    skuType() {
      return this.configTemp?.skuType || 1
    },
    // 带tab列表-选中状态 Tab 颜色
    selectedTabColor() {
      return this.configTemp?.selectedTabColor || ''
    },
    // 带tab列表-未选中状态 Tab 颜色
    unSelectedTabColor() {
      return this.configTemp?.unSelectedTabColor || ''
    },
    // Official-标签背景色
    pcTagBckColor() {
      return {
        backgroundColor: this.configTemp?.pc_tagBckColor || '',
      }
    },
    // Official-标签字体颜色
    pcTagTextColor() {
      return {
        color: this.configTemp?.pc_tagTextColor || '',
      }
    },
    // 信任与奖励-模块字体颜色
    pcMouldTextColor() {
      return {
        color: this.configTemp?.pc_mouldTextColor || '',
      }
    },
    // 底部栏- 模块背景颜色
    pMouldBckColor() {
      return {
        backgroundColor: this.configTemp?.pc_mouldBckColor || '',
      }
    },
    // 底部栏- 字体颜色
    pcTextColor() {
      return {
        color: this.configTemp?.pc_textColor || '',
      }
    },
  },
}
